export const AUTH_PROJECT_KIND = {
  no_authentication: 'no_authentication',
  hosted_login: 'hosted_login',
  coded_login: 'coded_login',
};
